import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Container, Typography, Divider, Stack, Button, Box } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive'
import Iconify from '../../components2/iconify/Iconify';
import Logo from '../../components2/logo/Logo';
import ExpertCallForm from '../../components/scheduleExpertCall.jsx/ExpertCallForm';
import { Link } from 'react-router-dom';
// components


// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function ExpertCall() {
  const mdUp = useResponsive('up', 'md');

  return (
    <>
      <Helmet>
        <title> Call Request | Minimal UI </title>
      </Helmet>

      <StyledRoot>
        <Logo
          sx={{
            position: 'fixed',
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />

        {mdUp && (
          <StyledSection>
            <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
              Hi, Speak to one of our experts
            </Typography>
            <img src="https://static.vecteezy.com/system/resources/previews/004/578/692/original/girl-working-at-computer-sending-email-free-vector.jpg" alt="login" />
          </StyledSection>
        )}

        <Container maxWidth="sm">
          <Box justifyContent='right' mt={2}>
              <a href='https://test-prep-app.vercel.app/' target="_blank">
                <Button variant='outlined'>Back Home</Button>
              </a>
              <Link to='/allcourses'>
                <Button variant='outlined'>Proceed to Courses</Button>
              </Link>
            </Box>
          <StyledContent>
            <Typography variant="h4" gutterBottom>
              Submit Call Request
            </Typography>

            <ExpertCallForm />
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}